// utils/recentsRouting.js
//
// Recents feeds are aggregated across collections, so the table an item routes
// to comes from the item rather than from the endpoint — a schema-level recents
// endpoint (&skip=0&schema=canada) carries no table at all. Prefer an explicit
// `source`; otherwise derive the table identifier from `collection_name`.
//
// Kept here so every recents surface resolves the same way. USHomePage,
// UKHomePage, MexicoHomePage and CanadaHomePage each still carry a local copy
// of these two functions and can be switched over whenever convenient.

/**
 * Turn a human-readable collection name into the snake_case table identifier
 * the API and routing use, e.g.
 *   "House of Commons" -> "house_of_commons"
 *   "Suprema Corte de Justicia de la Nación" -> "suprema_corte_de_justicia_de_la_nacion"
 */
 export function slugifyCollection(name) {
    return (name || '')
      .toString()
      .normalize('NFD')                  // split accented chars into base + combining mark
      .replace(/[\u0300-\u036f]/g, '')   // strip the combining marks (á -> a, ó -> o, ñ -> n)
      .toLowerCase()
      .trim()
      .replace(/[’'`.,()]/g, '')         // drop punctuation that never appears in table names
      .replace(/\s+/g, '_')              // spaces -> underscores
      .replace(/[^a-z0-9_]/g, '');       // anything else -> removed
  }
  
  /**
   * Resolve the table a recents item should link to.
   *
   * @param {Object} item - feed item
   * @param {string} [fallbackTable] - table parsed from the endpoint, if any
   */
  export function recentsTableFor(item, fallbackTable = '') {
    if (item && item.source) return item.source;
    return slugifyCollection(item && item.collection_name) || fallbackTable;
  }